import React, { PureComponent } from 'react';
import PropTypes from 'prop-types';
import { get } from 'lodash';
import { Spin, Col, Row, Button, Form, message } from 'antd';
import { connect } from 'react-redux';
import { withRouter } from 'react-router';
import { bindActionCreators } from 'redux';
import addLoad from 'services/decorators/addLoad';

import { downloadFile } from 'utils/downloadFile';
import { updateData } from 'actions/updateData';
import {
  getOsceDefaultProfile,
  exportToiOsce,
  downloadOsce,
} from 'actions/osceAdministration';
import profileFormDecorator from 'services/decorators/profileFormDecorator';
import Input from 'components/Form/formEditableLabel';
import { Box } from 'components/Styled';
import notification from 'services/decorators/notif';
import TableSelections from '../TableSelections';

const mapStateToProsp = ({ runtime }) => ({
  data: runtime.osceDefaultData,
});

const mapDispatchToProps = dispatch =>
  bindActionCreators({ dispatch, updateData, getOsceDefaultProfile }, dispatch);

@withRouter
@notification('output')
@addLoad({ i18Name: 'output' })
@connect(
  mapStateToProsp,
  mapDispatchToProps,
)
@profileFormDecorator({ i18Name: 'output' })
export default class ExportData extends PureComponent {
  static propTypes = {
    data: PropTypes.object,
  };

  static contextTypes = {
    form: PropTypes.object,
  };

  componentDidMount() {
    this.props.getOsceDefaultProfile();
  }

  exportIOsce = osceIds => async () => {
    try {
      const { props } = this;
      await props.stateloading(exportToiOsce({ osceIds }), {
        noShowCatch: true,
      });
      props.notifySuccess('successExport');
    } catch (error) {
      const errMsg =
        error.response.data.message || this.props.translate('all', 'error');
      message.error(errMsg);
    }
  };

  download = osce => async () => {
    const { props } = this;
    const resp = await props.stateloading(downloadOsce({ osceId: osce.id }));
    downloadFile(resp, `${osce.name}.iosce`);
  };

  renderRow = (text, record) => (
    <span className="inline-flex-center">
      <span>{record.name}.iosce</span>
      <span className="spacer" />
      <span className="editable-row-operations">
        <a className="action-btn-single" onClick={this.download(record)}>
          {this.props.translate('download')}
        </a>
      </span>
    </span>
  );

  getButtons = ({ disabled: _disabled, selected }) => {
    const { props } = this;
    const { translate } = props;
    const disabled = _disabled || props.loading;
    return (
      <React.Fragment>
        <Button
          className="sendInvitations-btn"
          disabled={disabled}
          onClick={this.exportIOsce(selected)}
        >
          {translate('exportIOSCE')}
        </Button>
      </React.Fragment>
    );
  };

  renderPassword = password => {
    if (!password) return null;
    const arr = [];
    for (let i = 0; i < password.length; i++) arr.push('*');
    return arr;
  };

  render() {
    const { translate, data } = this.props;
    return (
      <Spin spinning={this.props.loading}>
        <Form>
          <Row>
            <Col xs={24} lg={12}>
              <Input disabled name="host" initialValue={get(data, 'host')} />
              <Input
                disabled
                name="basePath"
                initialValue={get(data, 'remoteDirPath')}
              />
            </Col>
            <Col xs={24} lg={12}>
              <Input
                disabled
                name="username"
                initialValue={get(data, 'username')}
              />
            </Col>
          </Row>
        </Form>
        <Box className="horizontal-line" mb={3} />
        <Row className="table-with-action">
          <Col span={12}>
            <TableSelections
              renderRow={this.renderRow}
              getButtons={this.getButtons}
              url="/osce"
              sendParams={{ semesterId: this.props.match.params.semesterId }}
              title={translate('exportedfiles')}
            />
          </Col>
        </Row>
      </Spin>
    );
  }
}
